import { TextModel } from "../GeneratedClients/FreeBillApi";

const textModelTemplate: TextModel = {
  introduction: "Hiermit berechnen wir gem. unserer von Ihnen anerkannten AGB:",
  terms: "",
  ending: "Wir bedanken uns für Ihren Auftrag.",
  isSmallBusinessNotice: "Kein Umsatzsteuerausweis aufgrund Anwendung der Kleinunternehmerregelung gemäß § 19 UStG.",
  reverseChargeNotice: "Reverse-Charge-Verfahren: Die Steuerschuldnerschaft geht auf den Leistungsempfänger über.",
  deliveryDateNotice: "Sofern nicht anders angegeben entspricht das Leistungsdatum dem Rechnungsdatum."
}

export default textModelTemplate